import { CustomDoc } from "./../../../vo/custom-doc";
import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	AfterViewInit,
} from "@angular/core";
import { CourseContextModelService } from "../../../models/course-context-model.service";
import { Subscription } from "rxjs";
import { UtilityScripts } from "app/helpers/utility-scripts";
import { DescriptorModelService } from "app/core/models/descriptor-model.service";
import { ModalPopupService } from "app/services/modal-popup.service";
import { TrackingManager } from "app/core/tracking/tracking-manager";
import { AppServices } from "app/app.services";
import { ScreenControllerService } from "app/core/controls/screen-controller.service";
import { CourseControllerService } from "app/core/controls/course-controller.service";
import { ApplicationModel } from "../../../models/application.model";
import { ApplicationUtilityService } from "../../../../services/application-utility.service";
import { OrientationModelService } from "app/core/models/orientation-model.service";
import { AppHeaderModelServiceAdaptive } from "./app-header-model.service";

@Component({
	selector: "app-app-header-adaptive",
	templateUrl: "./app-header.component.html",
	styleUrls: ["./app-header.component.css"],
})
export class AppHeaderComponentAdaptive implements OnInit {
	public fullImagePath: string;
	public toggleUser = "page-top-header-user-nav";
	public toggleDocs = false;
	private updateScreenSubscription: Subscription;

	private percentComplete: string = "";
	//private presentationModes: PresentationOption[];
	public pModeOpen: boolean;
	private courseCompletedSubscription: Subscription;
	private isCourseCompleted = false;
	private percentVal = 0;

	@Input() textDirection: string;
	@Input() header_inner_wrap: string;
	@Output() toggleIW = new EventEmitter<string>();
	@Output() languageUpdate = new EventEmitter<string>();

	@Input() curPageNum: number;
	@Input() totalPages: number;
	@Input() totalPagesInCourse: number;
	showProgressCard: boolean = false;

	constructor(
		private appheaderModelService: AppHeaderModelServiceAdaptive,
		private courseContextModelService: CourseContextModelService,
		private descriptorService: DescriptorModelService,
		private popupService: ModalPopupService,
		private appServices: AppServices,
		public CourseControllerService: CourseControllerService,
		private screenController: ScreenControllerService,
		private appUtilityService: ApplicationUtilityService,
		public orientationModel: OrientationModelService
	) {
		this.fullImagePath = "assets/ng_logo.svg";
		this.updateScreenSubscription =
			this.courseContextModelService.notifier.subscribe((data) => {
				this.closeDocs(data);
			});
		this.courseCompletedSubscription = appServices.courseCompleted$.subscribe(
			(event) => this.courseCompletedHandler()
		);
	}

	ngOnInit() {
		console.log(
			"UtilityScripts.isMobileDevice  :" + UtilityScripts.isMobileDevice()
		);
	}

	toggleInnerWrap(event) {
		if (this.header_inner_wrap === "page-inner-wrap") {
			this.header_inner_wrap = "page-inner-wrap toggled";
			this.appServices.emitMenuToggle("open");
		} else {
			this.header_inner_wrap = "page-inner-wrap";
			this.appServices.emitMenuToggle("close");
		}
		this.toggleIW.emit(this.header_inner_wrap);
	}

	toggleUserNav(event) {
		if (this.toggleUser === "page-top-header-user-nav") {
			this.toggleUser = "page-top-header-user-nav open";
		} else {
			this.toggleUser = "page-top-header-user-nav";
		}
	}

	toggleDocNav(event) {
		this.toggleDocs = !this.toggleDocs;
	}

	langSelect(event) {
		// console.log("langSelect  ",event);
		ApplicationModel.instance.flowDirection = this.textDirection =
			event.direction;
		this.languageUpdate.emit(event.language);
		//this.CourseControllerService.updateGeoLocation();
	}
	private documentClick(doc) {
		// doc.isVisible = !doc.isVisible;
		doc.isVisible = true;
		ApplicationModel.instance.videoOverlay = true;
		this.appServices.pauseVideo();
		this.appheaderModelService.customDocs.forEach((item) => {
			if (doc.iconTarget !== item.iconTarget) {
				item.isVisible = false;
			}
		});
		this.courseContextModelService.customDoc = doc.isVisible ? doc : null;
	}
	private closeDocs(data) {
		this.appheaderModelService.customDocs.forEach((item) => {
			item.isVisible = false;
		});
		this.courseContextModelService.customDoc = null;
	}
	public get appheaderModelServiceVal(): AppHeaderModelServiceAdaptive {
		return this.appheaderModelService;
	}
	public exitButtonClickHandler() {
		this.appUtilityService.pauseCoursePlayer();
		this.appUtilityService.exitCourse();
	}
	//
	ngOnChanges() {
		this.updateProgress();
		this.updatePercentVal();
		//this.presentationModes = this.courseContextModelService.presentationModes;
	}

	private courseCompletedHandler() {
		this.isCourseCompleted = true;
		this.updateProgress();
		this.updatePercentVal();
	}

	private updateProgress() {
		let percentage;
		if (
			this.isCourseCompleted ||
			ApplicationModel.instance.mode == "demo" ||
			TrackingManager.instance.trackingVO.lessonStatus == "p" ||
			TrackingManager.instance.trackingVO.lessonStatus == "c"
		)
			this.percentComplete = "100%";
		else if (this.curPageNum == this.totalPagesInCourse - 1)
			this.percentComplete = "99%";
		else {
			percentage = Math.floor(
				(this.curPageNum / this.totalPagesInCourse) * 100
			);
			this.percentComplete = percentage + "%";
			if (percentage > 99) {
				this.percentComplete = "99%";
			}
		}
	}

	public get percentCompleteVal(): string {
		return this.percentComplete;
	}

	private updatePercentVal() {
		if (this.totalPagesInCourse > 0) {
			if (
				this.isCourseCompleted ||
				ApplicationModel.instance.mode == "demo" ||
				TrackingManager.instance.trackingVO.lessonStatus == "p" ||
				TrackingManager.instance.trackingVO.lessonStatus == "c"
			)
				this.percentVal = 100;
			else if (this.curPageNum == this.totalPagesInCourse - 1)
				this.percentVal = 99;
			else {
				this.percentVal = Math.ceil(
					(this.curPageNum / this.totalPagesInCourse) * 100
				);
				if (this.percentVal > 99) {
					this.percentVal = 99;
				}
			}
		}
	}
	public get percentProgressVal(): number {
		return this.percentVal;
	}
	public get circularProgress(): string {
		return "p" + this.percentVal;
	}
	//
	public isMobile() {
		return UtilityScripts.isMobileDevice();
	}
	public get trackingManager() {
		return TrackingManager.instance;
	}

	public spinnerClickhandler(event) {
		this.showProgressCard = this.showProgressCard == false ? true : false;
	}
	public progressCardClosehandler(event) {
		if (event && event.closed) {
			this.showProgressCard = !event.closed;
		}
	}
}
